<template>
  <div v-if="!ready" v-loading="!ready" element-loading-text="拼命加载中" class="page-loading"></div>
  <div v-else>
    <div class="clearfix m-b-5">
      <h3 class="pull-left m-v-0">
        <span v-if="channel&&channel.name">{{channel.name}} -</span>
        <span v-if="school&&school.name">{{school.name}} -</span>
        <span>批量导入</span>
      </h3>
    </div>
    <el-form :model="form" ref="form" :rules="rules" label-position="top">
      <div class="p-20 m-b-10 bg-lightwarning border border-lightgrey">
        批量导入教师，一行为一条教师记录
      </div>
      <div class="flex">
        <div v-for="(item, index) in props" :key="index" :style="{flex:item.flex}">
          <el-form-item :prop="item.prop" :label="item.name">
            <el-input type="textarea" :autosize="{minRows: 5}" v-model="form[item.prop]"></el-input>
          </el-form-item>
        </div>
      </div>
      <div class="text-center m-v-10">
        <el-button type="primary" size="cons" @click="submit" :loading="submit_loading>0">提交</el-button>
        <el-button type="default" size="cons" @click="$router.back()">取消</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import * as Channel from 'api/channel'
import * as School from 'api/school'
import * as Teacher from 'api/teacher'
import * as Subject from 'api/configuration/subject'
import * as regexp from 'utils/regexp'
import * as validator from 'utils/validator'
import * as rules from 'common/rules'

export default {
  data () {
    let getUniqueCheck = item => (rule, value, callback) => {
      if (!value) return callback()
      let list = value.split(/\r?\n/g).map(v => v.trim()).filter(v => v)
      let exists = Object.create(null)
      for (let val of list) {
        if (exists[val]) return callback(`${item.name}不能重复：${val}`)
        exists[val] = true
      }
      callback()
    }
    let getChecker = validator => (rule, value, callback) => {
      if (!value) return callback()
      for (let val of value.split(/[\r\n]+/g)) {
        val = val.trim()
        if (!val) continue
        let message = validator.call(this, val)
        if (message) return callback(message)
      }
      callback()
    }
    let props = [
      {item_prop: 'name', name: '姓名', required: true, validator: this.isInvalidName, flex: 1},
      {item_prop: 'number', name: '工号', unique: true, validator: this.isInvalidNumber, flex: 1},
      {item_prop: 'gender', name: '性别', validator: this.isInvalidGender, flex: 0.5},
      {item_prop: 'id_number', name: '身份证', unique: true, validator: this.isInvalidIdNumber, flex: 1.5},
      {item_prop: 'subject', name: '任教学科', validator: this.isInvalidSubject, flex: 1},
      {item_prop: 'phone', name: '手机号', validator: this.isInvalidPhone, flex: 1},
      {item_prop: 'email', name: '邮箱', validator: this.isInvalidEmail, flex: 1},
    ]
    let form = {}
    props.forEach(item => {
      item.prop = item.item_prop + 's'
      form[item.prop] = ''
    })
    let getRule = props => {
      let generated_rules = {}
      props.forEach(item => {
        let rule = []
        if (item.required) rule.push(rules.required(item.name + '为必填项'))
        if (item.validator) rule.push({validator: getChecker(item.validator), trigger: 'blur,change'})
        if (item.unique) rule.push({validator: getUniqueCheck(item), trigger: 'blur,change'})
        if (rule.length) generated_rules[item.prop] = rule
      })
      return generated_rules
    }
    return {
      ready: false,
      form,
      school: null,
      submit_loading: 0,
      props: props,
      rules: getRule(props),
    }
  },
  methods: {
    init () {
      this.ready = false
      this.$guard()(async () => {
        let query = this.$query
        let [channel, school, subjects] = await Promise.all([
          query.channel_uid ? Channel.get(query) : null,
          query.school_uid ? School.get(query) : null,
          Subject.list(),
        ])
        this.channel = channel
        this.school = school
        this.subjects = subjects
        this.ready = true
      })
    },
    async submit () {
      if (!await this.$validate(this.$refs.form)) return
      this.$guard(this, 'submit_loading')(async () => {
        let teachers = [], invalid_teachers = []
        this.parseTeacher().forEach(s => {
          this.isInvalidTeacher(s) ? invalid_teachers.push(s) : teachers.push(s)
        })
        let fails = await Teacher.batch_import({school_uid: this.$query.school_uid, teachers}) || []
        let errors = invalid_teachers.concat(fails)
        invalid_teachers = invalid_teachers.filter(t => t.name || t.number || t.id_number)
        let message = ''
        let to_str = l => l.map(t => {
          let s = t.name
          let n = t.id_number || t.number
          if (n) s += '(' + n + ')'
          return s
        }).join('、')
        if (invalid_teachers.length) {
          message += '以下教师由于不合法信息而无法保存：\n' + to_str(invalid_teachers) + '\n'
        }
        if (fails.length) {
          message += '以下教师由于工号/身份证号重复而保存失败：\n' + to_str(fails) + '\n'
        }
        if (errors.length) {
          if (message) this.$alert(message, '部分教师未保存')
          this.resetForm(errors)
        } else {
          this.$message.success('更新成功')
          this.resetForm()
        }
      })
    },
    isInvalidNumber (val) {
      val = val ? val.trim() : ''
      if (!val) return
      if (!regexp.student_number().test(val)) return `工号必须为3~10位的数字：${val}`
    },
    isInvalidName (val) {
      val = val ? val.trim() : ''
      if (!val) return '姓名为必填项'
      if (!regexp.name().test(val)) return `姓名包含非法字符：${val}`
    },
    isInvalidGender (val) {
      val = val ? val.trim() : ''
      if (!val) return
      if (!['男', '女', '其他'].includes(val)) return `性别错误：${val}(支持“男/女/其他”)`
    },
    isInvalidPhone (val) {
      val = val ? val.trim() : ''
      if (!val) return
      if (!regexp.phone().test(val)) return `手机号格式错误：${val}`
    },
    isInvalidEmail (val) {
      val = val ? val.trim() : ''
      if (!val) return
      if (!regexp.email().test(val)) return `邮箱格式错误：${val}`
    },
    isInvalidSubject (val) {
      val = val ? val.trim() : ''
      if (!val) return
      if (!this.subjects.includes(val)) return `非法学科：${val}`
    },
    isInvalidIdNumber (val) {
      val = val ? val.trim() : ''
      if (!val) return
      if (!validator.id_number(val)) return `身份证号不合法：${val}`
    },
    isInvalidTeacher (s) {
      for (let item of this.props) {
        if (item.validator) {
          let message = item.validator.call(this, s[item.item_prop])
          if (message) return message
        }
      }
    },
    parseTeacher () {
      let teachers = []
      this.props.forEach(item => {
        let data = this.form[item.prop].split(/\r?\n/g)
        for (let i = 0, len = data.length; i < len; i++) {
          let teacher = teachers[i]
          if (!teacher) teachers.push(teacher = {})
          teacher[item.item_prop] = data[i].trim()
        }
      })
      teachers = teachers.filter(teacher => {
        let has_value = false
        this.props.forEach(item => {
          teacher[item.item_prop] = teacher[item.item_prop] || ''
          if (!has_value && teacher[item.item_prop]) has_value = true
        })
        return has_value
      })
      teachers.forEach(teacher => {
        teacher.grade = Subject.getGrade(teacher.subject)
        teacher.roles = ['teacher']
      })
      return teachers
    },
    resetForm (teachers) {
      if (teachers && teachers.length) {
        this.props.forEach(item => {
          this.form[item.prop] = ''
          if (teachers) teachers.forEach(s => this.form[item.prop] += (s[item.item_prop] || '') + '\r\n')
        })
      } else {
        this.$refs.form.resetFields()
      }
    },
  },
  created () {
    this.init()
  },
  watch: {
    $route () { if (!this.$dontReload) this.init() },
  },
}
</script>

<style scoped lang="scss">
@import "src/scss/var/colors";

.form {
  max-width: 800px;
  background-color: $color-block-background;
  padding: 20px;
}

.flex {
  display: flex;
  margin: 0 -5px;
  > div {
    flex: 1;
    padding: 0 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/account/teacher/TeacherBatchImport.vue